import { render, staticRenderFns } from "./DriversBoxPlotChart.vue?vue&type=template&id=5628881a"
import script from "./DriversBoxPlotChart.vue?vue&type=script&lang=js"
export * from "./DriversBoxPlotChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports